import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { TCircle } from '@containers/BalanceChart/types';

import Circle from './Circle';

import style from './DonutChart.scss';

const cn = bemCssModules(style, 'DonutChart');

export type TDonutChart = {
  total: string;
  circles: TCircle[];
  isOverview?: boolean;
};

const DonutChart: CustomFC<TDonutChart> = ({ total, circles, isOverview = false, className }) => {
  const { t } = useTranslation();

  const isEmpty = !circles.length;

  return (
    <div className={cn(null, [className])}>
      <svg className={cn('svg')} viewBox="0 0 36 36" role="img">
        {circles
          .map(({ dashArray, color, label, dashOffset }) => (
            <Circle
              key={label}
              color={`var(${color})`}
              dashOffset={dashOffset}
              dashArray={dashArray}
            />
          ))
          .reverse()}
        <Circle
          className={cn('grey-circle', { withAnimation: !isEmpty })}
          color="var(--color-main-border)"
          dashOffset={25}
          strokeWidth={2.1}
          dashArray="100 0"
        />
      </svg>
      <div className={cn('text', { isEmpty })}>
        <div className={cn('total', { isOverview })}>{total}</div>
        <div className={cn('label')}>{t('public.total_balance')}</div>
      </div>
    </div>
  );
};

export default DonutChart;
